// Keep hidden mobile videos off the network; lifecycle follows the section DOM.
if (!customElements.get('preme-hero-media')) {
  customElements.define('preme-hero-media', class extends HTMLElement {
    connectedCallback() {
      this.video = this.querySelector('video');
      if (!this.video || this.events) return;
      this.events = new AbortController();
      this.desktop = matchMedia('(min-width: 1025px)');
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.inView = false;
      const signal = this.events.signal;
      const update = () => this.updatePlayback();
      this.desktop.addEventListener('change', update, { signal });
      this.motion.addEventListener('change', update, { signal });
      document.addEventListener('visibilitychange', update, { signal });
      this.observer = new IntersectionObserver(([entry]) => {
        this.inView = entry.isIntersecting;
        this.updatePlayback();
      });
      this.observer.observe(this);
      this.updatePlayback();
    }

    loadSource() {
      const source = this.video.querySelector('source');
      if (source && !source.hasAttribute('src')) {
        source.src = source.dataset.src;
        this.video.load();
      }
    }

    play() {
      if (!this.desktop.matches || document.hidden) return;
      this.loadSource();
      const playing = this.video.play();
      // Leave the approved poster visible when automatic playback is rejected.
      if (playing?.catch) playing.catch(() => {});
    }

    updatePlayback() {
      if (!this.desktop.matches || this.motion.matches || !this.inView || document.hidden) {
        this.video.pause();
      } else {
        this.play();
      }
    }

    disconnectedCallback() {
      this.events?.abort();
      this.observer?.disconnect();
      this.video?.pause();
      this.events = null;
    }
  });
}
